import type { AbilityBuilder, MongoQuery } from '@casl/ability'
import type { AppAbility } from '~/types/authorization.type'
import type { Invoice } from '~/types/invoice.type'
import type { User } from '~/types/user.type'
import { userRoles } from '../roles'

export function defineInvoiceAbilities(abilityBuilder: AbilityBuilder<AppAbility>, user: User) {
  const { can } = abilityBuilder

  const roles = userRoles(user)

  if (roles.administrator) {
    can('read', 'invoices')
    can(['read', 'create', 'update'], 'invoice-bank-sync')
    can(['create', 'read', 'update', 'delete', 'restore'], 'invoice')
  }
  else {
    if (roles.accounting) {
      can('read', ['invoice', 'invoices'])
    }
    if (roles.client_lead) {
      type InvoiceQuery = MongoQuery<Invoice>
      can('create', 'invoice')
      can('read', 'invoices')
      can(['read', 'update'], 'invoice', {
        creatorId: user.id,
      } as InvoiceQuery)
    }
  }
}
